import { render, staticRenderFns } from "./dialog-header.vue?vue&type=template&id=3388ae1c&scoped=true"
import script from "./dialog-header.vue?vue&type=script&lang=js"
export * from "./dialog-header.vue?vue&type=script&lang=js"
import style0 from "./dialog-header.vue?vue&type=style&index=0&id=3388ae1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3388ae1c",
  null
  
)

export default component.exports